import { useTranslation } from "react-i18next";

import { InfoBanner } from "pstat-design-system/banner";
import { Button } from "pstat-design-system/shared/Button";
import { P } from "pstat-design-system/text/paragraph";
// @flow

export const PolicyGenAnnouncement = () => {
  const { t } = useTranslation();
  return (
    <InfoBanner width="100%">
      <div>
        <div>
          <P fontWeight="bold">
            {t("home.homeContent.policyGenAnnouncement.title")}
          </P>
          <br />
          <P>{t("home.homeContent.policyGenAnnouncement.body")}</P>
        </div>
        <br />
        <Button
          buttonStyle="tertiary"
          onClick={() =>
            window.open(
              "https://rldatix-public.zendesk.com/hc/en-us/articles/23124302626460-What-is-PolicyGen",
              "_blank"
            )
          }
        >
          Learn more
        </Button>
      </div>
    </InfoBanner>
  );
};
